import { render, staticRenderFns } from "./AdminCancelation.vue?vue&type=template&id=dd7f8f64&"
import script from "./AdminCancelation.vue?vue&type=script&lang=js&"
export * from "./AdminCancelation.vue?vue&type=script&lang=js&"
import style0 from "./AdminCancelation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports